import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";

export default function DetailNilaiKhususPage({
  selectedMatpel,
  selectedNilaiKhusus,
  setSelectedNilaiKhusus,
  selectedAcademicYearId,
  selectedSemesterId,
  getToken,
  getBranchId,
  getSchoolId,
  nameCollator,
  ToastError,
  ToastSuccess,
}) {
  const [activeTab, setActiveTab] =
    useState("detailnilaikhusus");

  const [
    detailNilaiKhusus,
    setDetailNilaiKhusus,
  ] = useState(null);

  const [
    subActivityData,
    setSubActivityData,
  ] = useState([]);

  const [
    selectedKelasId,
    setSelectedKelasId,
  ] = useState("");

  const [
    isFetchingDetail,
    setIsFetchingDetail,
  ] = useState(false);

  const [
    isFetchingAspek,
    setIsFetchingAspek,
  ] = useState(false);

  const [scoreApiData, setScoreApiData] =
    useState(null);

  const [
    isFetchingScores,
    setIsFetchingScores,
  ] = useState(false);

  const [scoreDrafts, setScoreDrafts] =
    useState({});

  const [
    savingScoreKeys,
    setSavingScoreKeys,
  ] = useState({});

  const [
    savedScoreKey,
    setSavedScoreKey,
  ] = useState("");

  const safeStr = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value);
  };

  const getAuthHeaders = () => ({
    Authorization:
      typeof getToken === "function"
        ? getToken()
        : localStorage.getItem("token") ||
          "",

    "Content-Type": "application/json",
    Accept: "application/json",
  });

  const resolveBranchId = () => {
    if (typeof getBranchId === "function") {
      try {
        return (
          getBranchId() ||
          localStorage.getItem(
            "ysb_branch_id"
          ) ||
          ""
        );
      } catch (error) {
        return (
          localStorage.getItem(
            "ysb_branch_id"
          ) || ""
        );
      }
    }

    return (
      localStorage.getItem("ysb_branch_id") ||
      ""
    );
  };

  const resolveSchoolId = () => {
    if (typeof getSchoolId === "function") {
      try {
        return (
          getSchoolId() ||
          localStorage.getItem(
            "ysb_school_id"
          ) ||
          ""
        );
      } catch (error) {
        return (
          localStorage.getItem(
            "ysb_school_id"
          ) || ""
        );
      }
    }

    return (
      localStorage.getItem("ysb_school_id") ||
      ""
    );
  };

  const cleanStorageValue = (value) => {
    return safeStr(value).replace(
      /[|&;$%@"<>()+,]/g,
      ""
    );
  };

  const resolveUserId = () => {
    return cleanStorageValue(
      selectedNilaiKhusus?.update_by ||
        selectedNilaiKhusus?.create_by ||
        selectedNilaiKhusus?.raw
          ?.update_by ||
        selectedNilaiKhusus?.raw
          ?.create_by ||
        localStorage.getItem("id_admin") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("id_user") ||
        localStorage.getItem("userId") ||
        ""
    );
  };

  const resolveTeacherId = () => {
    return cleanStorageValue(
      localStorage.getItem("teacher_ID") ||
        selectedNilaiKhusus
          ?.ysb_teacher_id ||
        selectedNilaiKhusus?.raw
          ?.ysb_teacher_id ||
        resolveUserId() ||
        ""
    );
  };

  const showError = (title) => {
    if (
      ToastError &&
      typeof ToastError.fire === "function"
    ) {
      ToastError.fire({
        icon: "error",
        title:
          title || "Terjadi kesalahan",
      });
    }
  };

  const showSuccess = (title) => {
    if (
      ToastSuccess &&
      typeof ToastSuccess.fire ===
        "function"
    ) {
      ToastSuccess.fire({
        icon: "success",
        title:
          title ||
          "Nilai berhasil diupdate",
      });
    }
  };

  const collator = useMemo(() => {
    return (
      nameCollator ||
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      })
    );
  }, [nameCollator]);

  const handleBackToNilaiKhusus = (
    event
  ) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    if (
      typeof setSelectedNilaiKhusus ===
      "function"
    ) {
      setSelectedNilaiKhusus(null);
    }
  };

  const getArrayFromResponse = (
    responseData
  ) => {
    if (
      Array.isArray(
        responseData?.data?.data
      )
    ) {
      return responseData.data.data;
    }

    if (
      Array.isArray(
        responseData?.data?.rows
      )
    ) {
      return responseData.data.rows;
    }

    if (
      Array.isArray(responseData?.data)
    ) {
      return responseData.data;
    }

    if (
      Array.isArray(
        responseData?.result?.data
      )
    ) {
      return responseData.result.data;
    }

    if (
      Array.isArray(responseData?.result)
    ) {
      return responseData.result;
    }

    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  };

  const getDetailObjectFromResponse = (
    responseData
  ) => {
    if (
      responseData?.data &&
      !Array.isArray(responseData.data) &&
      typeof responseData.data ===
        "object"
    ) {
      return {
        ...responseData,
        ...responseData.data,
      };
    }

    if (
      responseData?.result &&
      !Array.isArray(responseData.result) &&
      typeof responseData.result ===
        "object"
    ) {
      return {
        ...responseData,
        ...responseData.result,
      };
    }

    if (
      responseData &&
      typeof responseData === "object"
    ) {
      return responseData;
    }

    return {};
  };

  const formatDate = (
    value,
    withTime = false
  ) => {
    if (!value) return "-";

    const raw = safeStr(value);

    if (
      /^\d{4}-\d{2}-\d{2}$/.test(raw)
    ) {
      const [year, month, day] =
        raw.split("-");

      const date = new Date(
        Number(year),
        Number(month) - 1,
        Number(day)
      );

      return date.toLocaleDateString(
        "id-ID",
        {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }
      );
    }

    const date = new Date(raw);

    if (Number.isNaN(date.getTime())) {
      return raw;
    }

    return date.toLocaleDateString(
      "id-ID",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",

        ...(withTime
          ? {
              hour: "2-digit",
              minute: "2-digit",
            }
          : {}),
      }
    );
  };

  const formatTime = (value) => {
    if (!value) return "-";

    const raw = safeStr(value);

    if (/^\d{2}:\d{2}/.test(raw)) {
      return raw.slice(0, 5);
    }

    return raw;
  };

  const toTitleCase = (value) => {
    const text = safeStr(value)
      .toLowerCase()
      .trim();

    if (!text) return "";

    return text.replace(
      /\w\S*/g,
      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1)
    );
  };

  const getNestedValue = (
    source,
    keys
  ) => {
    for (const keyPath of keys) {
      const value = keyPath
        .split(".")
        .reduce(
          (current, key) =>
            current?.[key],
          source
        );

      if (
        value !== undefined &&
        value !== null
      ) {
        return value;
      }
    }

    return undefined;
  };

  const scoreResponseObject = useMemo(() => {
    if (
      scoreApiData?.data &&
      !Array.isArray(scoreApiData.data) &&
      typeof scoreApiData.data ===
        "object"
    ) {
      return scoreApiData.data;
    }

    if (
      scoreApiData?.result &&
      !Array.isArray(
        scoreApiData.result
      ) &&
      typeof scoreApiData.result ===
        "object"
    ) {
      return scoreApiData.result;
    }

    return scoreApiData || {};
  }, [scoreApiData]);

  const mergedDetail = useMemo(() => {
    return {
      ...(selectedNilaiKhusus?.raw || {}),
      ...(selectedNilaiKhusus || {}),
      ...(detailNilaiKhusus || {}),
    };
  }, [
    selectedNilaiKhusus,
    detailNilaiKhusus,
  ]);

  const examId =
    selectedNilaiKhusus?.id ||
    selectedNilaiKhusus
      ?.ysb_exam_kokurikuler_id ||
    mergedDetail?.id ||
    mergedDetail
      ?.ysb_exam_kokurikuler_id ||
    "";

  const typeActivityObject = useMemo(() => {
    return (
      mergedDetail?.type_activity ||
      mergedDetail?.type_activities ||
      mergedDetail?.activity_type ||
      {}
    );
  }, [mergedDetail]);

  const subActivityObject = useMemo(() => {
    return (
      mergedDetail?.sub_activity ||
      mergedDetail?.sub_activities ||
      mergedDetail?.activity_aspect ||
      {}
    );
  }, [mergedDetail]);

  const detailTitle =
    mergedDetail?.title ||
    mergedDetail?.judul ||
    "Nilai Khusus";

  const matpelName =
    mergedDetail?.name_matpel ||
    mergedDetail?.nama_matpel ||
    selectedMatpel?.nama_matpel ||
    selectedMatpel?.name_matpel ||
    "-";

  const typeActivityId =
    mergedDetail
      ?.ysb_type_activities_id ||
    mergedDetail
      ?.ysb_type_activity_id ||
    typeActivityObject?.id ||
    "";

  const typeActivityName =
    mergedDetail?.type_activity_name ||
    mergedDetail?.name_activities ||
    mergedDetail
      ?.name_type_activity ||
    typeActivityObject
      ?.name_activities ||
    typeActivityObject?.name_activity ||
    "-";

  /*
   * Null sengaja tidak dilewati karena:
   * null atau 0 = Kuantitatif
   * 1 = Deskriptif
   */
  const inputTypeCandidates = [
    scoreResponseObject?.informasi_ujian
      ?.input_type,

    scoreResponseObject?.informasi_ujian
      ?.ysb_input_type_id,

    scoreResponseObject?.input_type,

    scoreResponseObject
      ?.ysb_input_type_id,

    scoreResponseObject
      ?.type_activity_terpilih
      ?.input_type,

    scoreResponseObject?.informasi_ujian
      ?.type_activity_terpilih
      ?.input_type,

    scoreApiData?.data?.informasi_ujian
      ?.input_type,

    scoreApiData?.data?.informasi_ujian
      ?.ysb_input_type_id,

    mergedDetail?.informasi_ujian
      ?.input_type,

    mergedDetail?.input_type,

    mergedDetail?.ysb_input_type_id,

    selectedNilaiKhusus?.input_type,

    selectedNilaiKhusus?.raw
      ?.input_type,

    typeActivityObject?.input_type,
  ];

  const resolvedInputType =
    inputTypeCandidates.find(
      (value) => value !== undefined
    );

  const rawInputType = Number(
    resolvedInputType
  );

  const inputTypeId =
    rawInputType === 1 ? 1 : 0;

  const isDescriptiveInput =
    inputTypeId === 1;

  const selectedSubActivityList =
    Array.isArray(
      mergedDetail?.sub_activities_list
    )
      ? mergedDetail.sub_activities_list
      : Array.isArray(
            mergedDetail?.sub_activity_list
          )
        ? mergedDetail.sub_activity_list
        : Array.isArray(
              selectedNilaiKhusus?.raw
                ?.sub_activities_list
            )
          ? selectedNilaiKhusus.raw
              .sub_activities_list
          : [];

  const selectedSubActivityId =
    mergedDetail
      ?.ysb_sub_activities_id ||
    mergedDetail
      ?.ysb_sub_activity_id ||
    selectedSubActivityList?.[0]
      ?.ysb_sub_activities_id ||
    selectedSubActivityList?.[0]
      ?.ysb_sub_activity_id ||
    selectedSubActivityList?.[0]?.id ||
    subActivityObject?.id ||
    "";

  const selectedSubActivityName = [
    ...selectedSubActivityList.map(
      (item) =>
        item?.name_sub_activities ||
        item?.name_sub_activity ||
        item?.nama_aspek ||
        item?.name_aspek ||
        ""
    ),

    mergedDetail?.sub_activity_name,
    mergedDetail?.name_sub_activities,
    mergedDetail?.name_sub_activity,
    subActivityObject?.name_sub_activities,
    subActivityObject?.name_sub_activity,
  ]
    .map((item) =>
      safeStr(item).trim()
    )
    .filter(Boolean)
    .filter(
      (item, index, array) =>
        array.indexOf(item) === index
    )
    .join(", ") || "-";

  const description =
    mergedDetail?.description ||
    mergedDetail?.keterangan ||
    mergedDetail?.information ||
    "-";

  const assessmentDate =
    mergedDetail?.date_create_exam ||
    selectedNilaiKhusus
      ?.date_create_exam ||
    selectedNilaiKhusus?.raw
      ?.date_create_exam ||
    mergedDetail?.date_exam ||
    mergedDetail?.date ||
    mergedDetail?.tanggal ||
    selectedNilaiKhusus?.created_at ||
    selectedNilaiKhusus?.raw
      ?.created_at ||
    mergedDetail?.created_at ||
    "";

  const assessmentTime =
    mergedDetail?.time ||
    mergedDetail?.time_exam ||
    mergedDetail?.jam ||
    "";

  const kelasOptions = useMemo(() => {
    const rawKelasList = Array.isArray(
      selectedMatpel?.kelas_list
    )
      ? selectedMatpel.kelas_list
      : [];

    const rawAssignments = Array.isArray(
      selectedMatpel?.assignments
    )
      ? selectedMatpel.assignments
      : [];

    const detailKelasObject =
      mergedDetail?.kelas ||
      mergedDetail?.class ||
      {};

    const mapKelas = new Map();

    [
      ...rawKelasList,
      ...rawAssignments,
    ].forEach((kelas, index) => {
      const kelasId =
        kelas?.ysb_kelas_id ||
        kelas?.kelas_id ||
        kelas?.id_kelas ||
        kelas?.id ||
        `kelas-${index}`;

      if (!kelasId) return;

      const previous =
        mapKelas.get(
          String(kelasId)
        ) || {};

      mapKelas.set(
        String(kelasId),
        {
          ...previous,
          ...kelas,

          id: kelasId,

          ysb_kelas_id: kelasId,

          ysb_branch_id:
            kelas?.ysb_branch_id ||
            previous?.ysb_branch_id ||
            "",

          ysb_school_id:
            kelas?.ysb_school_id ||
            previous?.ysb_school_id ||
            "",

          name:
            kelas?.nama_kelas ||
            kelas?.name_kelas ||
            kelas?.kelas_name ||
            kelas?.name_class ||
            previous?.name ||
            "Kelas",
        }
      );
    });

    const detailKelasId =
      mergedDetail?.ysb_kelas_id ||
      selectedNilaiKhusus
        ?.ysb_kelas_id ||
      "";

    if (
      detailKelasId &&
      !mapKelas.has(
        String(detailKelasId)
      )
    ) {
      mapKelas.set(
        String(detailKelasId),
        {
          id: detailKelasId,

          ysb_kelas_id:
            detailKelasId,

          ysb_branch_id:
            mergedDetail
              ?.ysb_branch_id ||
            "",

          ysb_school_id:
            mergedDetail
              ?.ysb_school_id ||
            "",

          name:
            mergedDetail?.kelas_name ||
            mergedDetail?.nama_kelas ||
            mergedDetail?.name_kelas ||
            detailKelasObject
              ?.nama_kelas ||
            detailKelasObject
              ?.name_kelas ||
            "Kelas",
        }
      );
    }

    return [...mapKelas.values()].sort(
      (a, b) =>
        collator.compare(
          safeStr(a?.name),
          safeStr(b?.name)
        )
    );
  }, [
    selectedMatpel,
    selectedNilaiKhusus,
    mergedDetail,
    collator,
  ]);

  const selectedKelas = useMemo(() => {
    return (
      kelasOptions.find(
        (kelas) =>
          String(kelas?.id || "") ===
          String(
            selectedKelasId || ""
          )
      ) || {}
    );
  }, [
    kelasOptions,
    selectedKelasId,
  ]);

  const selectedKelasName =
    selectedKelas?.name ||
    mergedDetail?.kelas_name ||
    mergedDetail?.nama_kelas ||
    mergedDetail?.name_kelas ||
    "-";

  const normalizeSubActivity = (
    item,
    index
  ) => {
    return {
      id:
        item?.id ||
        item?.ysb_sub_activity_id ||
        item?.ysb_sub_activities_id ||
        item?.sub_activity_id ||
        `aspek-${index}`,

      ysb_type_activities_id:
        item?.ysb_type_activities_id ||
        item?.ysb_type_activity_id ||
        item?.type_activity_id ||
        "",

      name:
        item?.name_sub_activities ||
        item?.name_sub_activity ||
        item?.nama_aspek ||
        item?.name_aspek ||
        item?.name ||
        `Aspek ${index + 1}`,

      raw: item,
    };
  };

  const detailAspects = useMemo(() => {
    const aspectCandidates = [
      scoreResponseObject?.header,
      scoreResponseObject?.headers,
      scoreResponseObject?.aspects,
      scoreResponseObject?.sub_activities,
      scoreResponseObject?.aspect_list,

      scoreApiData?.header,
      scoreApiData?.aspects,
      scoreApiData?.data?.header,
      scoreApiData?.data?.aspects,

      mergedDetail?.aspects,
      mergedDetail?.aspect_list,
      mergedDetail?.sub_activity_list,
      mergedDetail
        ?.sub_activities_list,
      mergedDetail?.data_aspek,
      mergedDetail?.detail_aspects,

      mergedDetail
        ?.informasi_penilaian
        ?.aspects,

      mergedDetail
        ?.informasi_penilaian
        ?.sub_activities,
    ];

    const aspectsFromDetail =
      aspectCandidates.find((item) =>
        Array.isArray(item)
      ) || [];

    const source =
      aspectsFromDetail.length > 0
        ? aspectsFromDetail
        : subActivityData;

    const aspectMap = new Map();

    source.forEach((item, index) => {
      const normalized =
        normalizeSubActivity(
          item,
          index
        );

      aspectMap.set(
        String(normalized.id),
        normalized
      );
    });

    if (
      selectedSubActivityId &&
      !aspectMap.has(
        String(selectedSubActivityId)
      )
    ) {
      aspectMap.set(
        String(selectedSubActivityId),
        {
          id: selectedSubActivityId,

          ysb_type_activities_id:
            typeActivityId,

          name:
            selectedSubActivityName ||
            "Aspek Kegiatan",

          raw: subActivityObject,
        }
      );
    }

    return [...aspectMap.values()].sort(
      (a, b) =>
        collator.compare(
          safeStr(a?.name),
          safeStr(b?.name)
        )
    );
  }, [
    mergedDetail,
    scoreApiData,
    scoreResponseObject,
    subActivityData,
    selectedSubActivityId,
    selectedSubActivityName,
    typeActivityId,
    subActivityObject,
    collator,
  ]);

  const displayAspects = useMemo(() => {
    if (detailAspects.length > 0) {
      return detailAspects;
    }

    return [
      {
        id: "default-score",
        name: "Nilai",
      },
    ];
  }, [detailAspects]);

  const getStudentArray = (source) => {
    if (Array.isArray(source)) {
      const looksLikeStudents =
        source.some(
          (item) =>
            item?.nama_lengkap ||
            item?.nama_siswa ||
            item?.student_name ||
            item?.student
        );

      if (looksLikeStudents) {
        return source;
      }
    }

    const candidates = [
      source?.data?.data?.data_murid,
      source?.data?.data?.students,
      source?.data?.data_murid,
      source?.data?.students,
      source?.result?.data?.data_murid,
      source?.result?.data?.students,
      source?.data_murid,
      source?.students,
      source?.murid,
      source?.data_students,
      source?.student_list,
      source?.list_students,
      source?.score_data?.data_murid,
      source?.score_data?.students,
      source?.nilai?.data_murid,
      source?.nilai?.students,
      source?.data_nilai?.data_murid,
      source?.result?.data_murid,
      source?.result?.students,
    ];

    return (
      candidates.find((item) =>
        Array.isArray(item)
      ) || []
    );
  };

  const getFlatScoreArray = (
    source
  ) => {
    const candidates = [
      source?.data?.data?.scores,
      source?.data?.data?.score_list,
      source?.data?.scores,
      source?.data?.score_list,
      source?.result?.data?.scores,
      source?.result?.data?.score_list,
      source?.scores,
      source?.score_list,
      source?.exam_scores,
      source?.nilai_siswa,
      source?.score_data?.scores,
      source?.result?.scores,
    ];

    return (
      candidates.find((item) =>
        Array.isArray(item)
      ) || []
    );
  };

  const students = useMemo(() => {
    const scoreStudents =
      getStudentArray(scoreApiData);

    const detailStudents =
      getStudentArray(mergedDetail);

    const directStudents =
      scoreStudents.length > 0
        ? scoreStudents
        : detailStudents;

    const scoreFlatScores =
      getFlatScoreArray(scoreApiData);

    const detailFlatScores =
      getFlatScoreArray(mergedDetail);

    const flatScores =
      scoreFlatScores.length > 0
        ? scoreFlatScores
        : detailFlatScores;

    const studentMap = new Map();

    directStudents.forEach(
      (item, index) => {
        const studentId =
          item?.ysb_student_id ||
          item?.student_id ||
          item?.id_student ||
          item?.ysb_murid_id ||
          item?.id ||
          `student-${index}`;

        const studentScores =
          [
            item?.data_nilai,
            item?.scores,
            item?.nilai_aspek,
            item?.score_list,
            item?.exam_scores,
            item
              ?.exam_kokurikuler_scores,
            item?.kokurikuler_scores,
            item?.score_details,
            item?.aspects,
          ].find((value) =>
            Array.isArray(value)
          ) || [];

        studentMap.set(
          String(studentId),
          {
            id: studentId,

            name:
              item?.nama_lengkap ||
              item?.nama_siswa ||
              item?.student_name ||
              item?.name_student ||
              item?.name ||
              "-",

            photo:
              item?.foto ||
              item?.photo ||
              item?.image ||
              item?.profile_picture ||
              item?.url_photo ||
              "",

            scores: studentScores,
            raw: item,
          }
        );
      }
    );

    flatScores.forEach(
      (score, index) => {
        const studentObject =
          score?.student ||
          score?.murid ||
          score?.siswa ||
          {};

        const studentId =
          score?.ysb_student_id ||
          score?.student_id ||
          score?.id_student ||
          score?.ysb_murid_id ||
          studentObject?.id ||
          `score-student-${index}`;

        const previous =
          studentMap.get(
            String(studentId)
          ) || {
            id: studentId,

            name:
              score?.nama_lengkap ||
              score?.nama_siswa ||
              score?.student_name ||
              studentObject
                ?.nama_lengkap ||
              studentObject?.nama_siswa ||
              studentObject?.name ||
              "-",

            photo:
              score?.foto ||
              score?.photo ||
              studentObject?.foto ||
              studentObject?.photo ||
              "",

            scores: [],
            raw: studentObject,
          };

        studentMap.set(
          String(studentId),
          {
            ...previous,

            scores: [
              ...(previous?.scores ||
                []),

              score,
            ],
          }
        );
      }
    );

    return [...studentMap.values()].sort(
      (a, b) =>
        collator.compare(
          safeStr(a?.name),
          safeStr(b?.name)
        )
    );
  }, [
    mergedDetail,
    scoreApiData,
    collator,
  ]);

  const getScoreRecordForAspect = (
    student,
    aspect
  ) => {
    const scores = Array.isArray(
      student?.scores
    )
      ? student.scores
      : [];

    const matchedScore = scores.find(
      (score) => {
        const scoreAspectId =
          score
            ?.ysb_sub_activities_id ||
          score
            ?.ysb_sub_activity_id ||
          score?.sub_activity_id ||
          score?.aspect_id ||
          score?.ysb_aspect_id ||
          score?.sub_activity?.id ||
          "";

        return (
          String(scoreAspectId) ===
          String(aspect?.id || "")
        );
      }
    );

    if (matchedScore) {
      return matchedScore;
    }

    if (
      displayAspects.length === 1 &&
      scores.length === 1
    ) {
      return scores[0];
    }

    if (
      aspect?.id === "default-score"
    ) {
      return scores[0] || {};
    }

    return {};
  };

  const getScoreForAspect = (
    student,
    aspect
  ) => {
    const matchedScore =
      getScoreRecordForAspect(
        student,
        aspect
      );

    if (
      matchedScore &&
      Object.keys(matchedScore).length >
        0
    ) {
      return (
        matchedScore?.score_value ??
        matchedScore?.score ??
        matchedScore?.value ??
        matchedScore?.nilai ??
        matchedScore?.ysb_value ??
        matchedScore?.result ??
        ""
      );
    }

    if (
      aspect?.id === "default-score"
    ) {
      return (
        student?.raw?.score_value ??
        student?.raw?.score ??
        student?.raw?.value ??
        student?.raw?.nilai ??
        student?.raw?.ysb_value ??
        ""
      );
    }

    const scoreByKey =
      student?.raw?.[aspect?.id] ??
      student?.raw
        ?.scores_by_aspect?.[
        aspect?.id
      ] ??
      student?.raw
        ?.nilai_by_aspect?.[
        aspect?.id
      ];

    return scoreByKey ?? "";
  };

  const getScoreTextForAspect = (
    student,
    aspect
  ) => {
    const record =
      getScoreRecordForAspect(
        student,
        aspect
      );

    if (
      record &&
      Object.keys(record).length > 0
    ) {
      return (
        record?.score_text ??
        record?.text ??
        record?.description ??
        record?.deskripsi ??
        ""
      );
    }

    if (
      aspect?.id === "default-score"
    ) {
      return (
        student?.raw?.score_text ??
        student?.raw?.text ??
        student?.raw?.description ??
        student?.raw?.deskripsi ??
        ""
      );
    }

    return "";
  };

  const getScoreCommentForAspect = (
    student,
    aspect
  ) => {
    const record =
      getScoreRecordForAspect(
        student,
        aspect
      );

    return (
      record?.comment ??
      record?.komentar ??
      record?.note ??
      record?.catatan ??
      ""
    );
  };

  const getScoreRecordId = (record) => {
    return (
      record?.id ||
      record
        ?.ysb_exam_kokurikuler_score_id ||
      record
        ?.exam_kokurikuler_score_id ||
      record?.score_id ||
      ""
    );
  };

  const getScoreCellKey = (
    studentId,
    aspectId
  ) => {
    return `${safeStr(
      studentId
    )}::${safeStr(aspectId)}`;
  };

  const totalStudentsFromApi =
    getNestedValue(scoreApiData, [
      "data.data.total_siswa",
      "data.total_siswa",
      "result.data.total_siswa",
      "result.total_siswa",
      "total_siswa",
      "data.data.total_students",
      "data.total_students",
      "total_students",
    ]) ??
    mergedDetail?.total_siswa ??
    mergedDetail?.total_students ??
    mergedDetail?.jumlah_siswa ??
    mergedDetail?.student_count ??
    null;

  const totalAssessedFromApi =
    getNestedValue(scoreApiData, [
      "data.data.total_dinilai",
      "data.total_dinilai",
      "result.data.total_dinilai",
      "result.total_dinilai",
      "total_dinilai",
      "data.data.total_assessed",
      "data.total_assessed",
      "total_assessed",
    ]) ??
    mergedDetail?.total_dinilai ??
    mergedDetail?.total_assessed ??
    mergedDetail?.sudah_dinilai ??
    mergedDetail?.assessed_count ??
    null;

  const totalStudents =
    totalStudentsFromApi !== null &&
    totalStudentsFromApi !== undefined
      ? Number(totalStudentsFromApi)
      : students.length;

  const totalAssessed = useMemo(() => {
    if (students.length === 0) {
      return Number(
        totalAssessedFromApi || 0
      );
    }

    return students.filter((student) => {
      const aspectsToCheck =
        detailAspects.length > 0
          ? detailAspects
          : displayAspects;

      return aspectsToCheck.every(
        (aspect) => {
          const key = getScoreCellKey(
            student?.id,
            aspect?.id
          );

          const draft =
            scoreDrafts[key];

          const value =
            isDescriptiveInput
              ? draft?.score_text ??
                getScoreTextForAspect(
                  student,
                  aspect
                )
              : draft?.score_value ??
                getScoreForAspect(
                  student,
                  aspect
                );

          return (
            value !== null &&
            value !== undefined &&
            safeStr(value).trim() !== ""
          );
        }
      );
    }).length;
  }, [
    totalAssessedFromApi,
    students,
    detailAspects,
    displayAspects,
    scoreDrafts,
    isDescriptiveInput,
  ]);

  const assessmentDateTime =
    useMemo(() => {
      if (
        !assessmentDate &&
        !assessmentTime
      ) {
        return "-";
      }

      return `${formatDate(
        assessmentDate
      )}${
        assessmentTime
          ? `, ${formatTime(
              assessmentTime
            )}`
          : ""
      }`;
    }, [
      assessmentDate,
      assessmentTime,
    ]);

  const getScoreData = async (
    kelasId = "",
    options = {}
  ) => {
    const targetKelasId =
      kelasId || selectedKelasId || "";

    if (!examId || !targetKelasId) {
      setScoreApiData(null);
      setScoreDrafts({});
      return;
    }

    const currentKelas =
      kelasOptions.find(
        (kelas) =>
          String(kelas?.id || "") ===
          String(targetKelasId)
      ) || {};

    if (!options?.silent) {
      setIsFetchingScores(true);
    }

    try {
      const payload = {
        ysb_branch_id:
          currentKelas
            ?.ysb_branch_id ||
          selectedNilaiKhusus
            ?.ysb_branch_id ||
          mergedDetail
            ?.ysb_branch_id ||
          resolveBranchId(),

        ysb_school_id:
          currentKelas
            ?.ysb_school_id ||
          selectedNilaiKhusus
            ?.ysb_school_id ||
          mergedDetail
            ?.ysb_school_id ||
          resolveSchoolId(),

        ysb_kelas_id:
          targetKelasId,

        ysb_exam_kokurikuler_id:
          examId,
      };

      const response = await APISD.post(
        "/api/exam-kokurikuler-score",
        payload,
        {
          headers: getAuthHeaders(),
        }
      );

      setScoreApiData(
        response?.data || {}
      );
    } catch (error) {
      console.log(
        "Gagal mengambil nilai siswa:",
        error
      );

      setScoreApiData(null);
      setScoreDrafts({});

      if (!options?.silent) {
        showError(
          error?.response?.data
            ?.message ||
            "Gagal mengambil data nilai siswa"
        );
      }
    } finally {
      if (!options?.silent) {
        setIsFetchingScores(false);
      }
    }
  };

  const updateScoreDraft = (
    student,
    aspect,
    field,
    value
  ) => {
    const key = getScoreCellKey(
      student?.id,
      aspect?.id
    );

    setScoreDrafts((previous) => {
      const current =
        previous[key] || {};

      return {
        ...previous,

        [key]: {
          ...current,
          [field]: value,
        },
      };
    });
  };

  const saveScore = async (
    student,
    aspect
  ) => {
    const studentId =
      student?.id || "";

    const aspectId =
      aspect?.id === "default-score"
        ? selectedSubActivityId || ""
        : aspect?.id || "";

    if (!studentId) {
      showError(
        "ID siswa tidak ditemukan"
      );
      return;
    }

    if (!aspectId) {
      showError(
        "ID aspek kegiatan tidak ditemukan"
      );
      return;
    }

    const key = getScoreCellKey(
      studentId,
      aspect?.id
    );

    if (savingScoreKeys[key]) {
      return;
    }

    const currentRecord =
      getScoreRecordForAspect(
        student,
        aspect
      );

    const draft =
      scoreDrafts[key] || {};

    const scoreValueRaw =
      draft?.score_value ??
      getScoreForAspect(
        student,
        aspect
      );

    const scoreText = safeStr(
      draft?.score_text ??
        getScoreTextForAspect(
          student,
          aspect
        )
    );

    const comment = safeStr(
      draft?.comment ??
        getScoreCommentForAspect(
          student,
          aspect
        )
    );

    const originalScoreValue =
      draft?.original_score_value ??
      getScoreForAspect(
        student,
        aspect
      );

    const originalScoreText = safeStr(
      draft?.original_score_text ??
        getScoreTextForAspect(
          student,
          aspect
        )
    );

    const originalComment = safeStr(
      draft?.original_comment ??
        getScoreCommentForAspect(
          student,
          aspect
        )
    );

    const hasChanged =
      isDescriptiveInput
        ? scoreText !==
            originalScoreText ||
          comment !== originalComment
        : safeStr(scoreValueRaw) !==
            safeStr(
              originalScoreValue
            ) ||
          comment !== originalComment;

    if (!hasChanged) {
      return;
    }

    let scoreValue = null;

    if (!isDescriptiveInput) {
      if (
        safeStr(scoreValueRaw).trim()
      ) {
        scoreValue = Number(
          scoreValueRaw
        );

        if (
          Number.isNaN(scoreValue)
        ) {
          showError(
            "Nilai harus berupa angka"
          );
          return;
        }
      }
    }

    const currentKelas =
      kelasOptions.find(
        (kelas) =>
          String(kelas?.id || "") ===
          String(
            selectedKelasId || ""
          )
      ) || {};

    const teacherId =
      resolveTeacherId();

    const updateBy = resolveUserId();

    const payload = {
      ysb_academic_year_id:
        selectedAcademicYearId ||
        mergedDetail
          ?.ysb_academic_year_id ||
        "",

      ysb_semester_id:
        selectedSemesterId ||
        mergedDetail
          ?.ysb_semester_id ||
        "",

      ysb_branch_id:
        currentKelas
          ?.ysb_branch_id ||
        mergedDetail
          ?.ysb_branch_id ||
        resolveBranchId(),

      ysb_school_id:
        currentKelas
          ?.ysb_school_id ||
        mergedDetail
          ?.ysb_school_id ||
        resolveSchoolId(),

      ysb_grade_level_id:
        currentKelas
          ?.ysb_grade_level_id ||
        selectedMatpel
          ?.ysb_grade_level_id ||
        mergedDetail
          ?.ysb_grade_level_id ||
        "",

      ysb_kelas_id:
        selectedKelasId,

      ysb_matpel_id:
        selectedMatpel
          ?.ysb_matpel_id ||
        selectedMatpel?.id ||
        mergedDetail
          ?.ysb_matpel_id ||
        "",

      ysb_exam_kokurikuler_id:
        examId,

      ysb_input_type_id:
        inputTypeId,

      ysb_student_id:
        studentId,

      ysb_type_activities_id:
        typeActivityId,

      ysb_sub_activities_id:
        aspectId,

      ysb_teacher_id:
        teacherId,

      score_value:
        isDescriptiveInput
          ? null
          : scoreValue,

      score_text:
        isDescriptiveInput
          ? scoreText
          : "",

      comment,

      update_by:
        updateBy,
    };

    const requiredFields = [
      [
        "ysb_academic_year_id",
        "Tahun ajaran",
      ],
      [
        "ysb_semester_id",
        "Semester",
      ],
      [
        "ysb_branch_id",
        "ID cabang",
      ],
      [
        "ysb_school_id",
        "ID sekolah",
      ],
      [
        "ysb_grade_level_id",
        "ID tingkatan",
      ],
      [
        "ysb_kelas_id",
        "ID kelas",
      ],
      [
        "ysb_matpel_id",
        "ID mata pelajaran",
      ],
      [
        "ysb_exam_kokurikuler_id",
        "ID nilai khusus",
      ],
      [
        "ysb_type_activities_id",
        "ID kegiatan",
      ],
      [
        "ysb_sub_activities_id",
        "ID aspek",
      ],
      [
        "ysb_teacher_id",
        "ID guru",
      ],
      [
        "update_by",
        "ID user",
      ],
    ];

    const missingField =
      requiredFields.find(
        ([field]) => !payload[field]
      );

    if (missingField) {
      showError(
        `${missingField[1]} tidak ditemukan`
      );
      return;
    }

    setSavingScoreKeys(
      (previous) => ({
        ...previous,
        [key]: true,
      })
    );

    try {
      const scoreId =
        draft?.score_id ||
        getScoreRecordId(
          currentRecord
        );

      const endpoint = scoreId
        ? `/api/exam-kokurikuler-score/${scoreId}`
        : "/api/exam-kokurikuler-score/default";

      const response = await APISD.put(
        endpoint,
        payload,
        {
          headers: getAuthHeaders(),
        }
      );

      const isSuccess =
        response?.status >= 200 &&
        response?.status < 300;

      if (!isSuccess) {
        throw new Error(
          response?.data?.message ||
            "Gagal menyimpan nilai"
        );
      }

      const savedRecord =
        response?.data?.data?.data ||
        response?.data?.data ||
        response?.data?.result ||
        response?.data ||
        {};

      const savedScoreId =
        getScoreRecordId(
          savedRecord
        ) ||
        scoreId ||
        "";

      setScoreDrafts(
        (previous) => ({
          ...previous,

          [key]: {
            ...(previous[key] || {}),

            score_id:
              savedScoreId,

            score_value:
              isDescriptiveInput
                ? ""
                : scoreValueRaw,

            score_text:
              isDescriptiveInput
                ? scoreText
                : "",

            comment,

            original_score_value:
              isDescriptiveInput
                ? ""
                : scoreValueRaw,

            original_score_text:
              isDescriptiveInput
                ? scoreText
                : "",

            original_comment:
              comment,
          },
        })
      );

      setSavedScoreKey(key);

      showSuccess(
        "Nilai berhasil diupdate"
      );

      window.setTimeout(() => {
        setSavedScoreKey(
          (current) =>
            current === key
              ? ""
              : current
        );
      }, 1400);
    } catch (error) {
      console.log(
        "Gagal menyimpan nilai:",
        error
      );

      showError(
        error?.response?.data
          ?.message ||
          error?.message ||
          "Gagal menyimpan nilai"
      );
    } finally {
      setSavingScoreKeys(
        (previous) => {
          const next = {
            ...previous,
          };

          delete next[key];

          return next;
        }
      );
    }
  };

  const getDetailNilaiKhusus =
    async (kelasId = "") => {
      if (!examId) return;

      setIsFetchingDetail(true);

      try {
        const currentKelas =
          kelasOptions.find(
            (kelas) =>
              String(
                kelas?.id || ""
              ) ===
              String(kelasId || "")
          ) || {};

        const response =
          await APISD.get(
            `/api/exam-kokurikuler/${examId}`,
            {
              headers:
                getAuthHeaders(),

              params: {
                ysb_kelas_id:
                  kelasId ||
                  selectedNilaiKhusus
                    ?.ysb_kelas_id ||
                  "",

                ysb_academic_year_id:
                  selectedAcademicYearId ||
                  selectedNilaiKhusus
                    ?.ysb_academic_year_id ||
                  "",

                ysb_semester_id:
                  selectedSemesterId ||
                  selectedNilaiKhusus
                    ?.ysb_semester_id ||
                  "",

                ysb_branch_id:
                  currentKelas
                    ?.ysb_branch_id ||
                  selectedNilaiKhusus
                    ?.ysb_branch_id ||
                  resolveBranchId(),

                ysb_school_id:
                  currentKelas
                    ?.ysb_school_id ||
                  selectedNilaiKhusus
                    ?.ysb_school_id ||
                  resolveSchoolId(),
              },
            }
          );

        setDetailNilaiKhusus(
          getDetailObjectFromResponse(
            response?.data
          )
        );
      } catch (error) {
        console.log(
          "Gagal mengambil detail nilai khusus:",
          error
        );

        setDetailNilaiKhusus(null);

        showError(
          error?.response?.data
            ?.message ||
            "Gagal mengambil detail nilai khusus"
        );
      } finally {
        setIsFetchingDetail(false);
      }
    };

  const getSubActivityData =
    async () => {
      if (!typeActivityId) {
        setSubActivityData([]);
        return;
      }

      setIsFetchingAspek(true);

      try {
        const response =
          await APISD.get(
            "/api/sub-activities",
            {
              headers:
                getAuthHeaders(),

              params: {
                page: 1,
                limit: 1000,
                ascending: true,
                search: "",
                branch: "",

                level:
                  localStorage.getItem(
                    "level"
                  ) || "developer",

                ysb_type_activities_id:
                  typeActivityId,
              },
            }
          );

        const rows =
          getArrayFromResponse(
            response?.data
          ).filter((item) => {
            const itemTypeId =
              item
                ?.ysb_type_activities_id ||
              item
                ?.ysb_type_activity_id ||
              item?.type_activity_id ||
              "";

            return (
              !itemTypeId ||
              String(itemTypeId) ===
                String(typeActivityId)
            );
          });

        setSubActivityData(rows);
      } catch (error) {
        console.log(
          "Gagal mengambil aspek kegiatan:",
          error
        );

        setSubActivityData([]);
      } finally {
        setIsFetchingAspek(false);
      }
    };

  const studentDraftSourceKey =
    useMemo(() => {
      return students
        .map((student) =>
          safeStr(student?.id)
        )
        .join("|");
    }, [students]);

  const aspectDraftSourceKey =
    useMemo(() => {
      return displayAspects
        .map((aspect) =>
          safeStr(aspect?.id)
        )
        .join("|");
    }, [displayAspects]);

  useEffect(() => {
    const nextDrafts = {};

    students.forEach((student) => {
      displayAspects.forEach(
        (aspect) => {
          const key =
            getScoreCellKey(
              student?.id,
              aspect?.id
            );

          const record =
            getScoreRecordForAspect(
              student,
              aspect
            );

          const scoreValue =
            getScoreForAspect(
              student,
              aspect
            );

          const scoreText =
            getScoreTextForAspect(
              student,
              aspect
            );

          const comment =
            getScoreCommentForAspect(
              student,
              aspect
            );

          nextDrafts[key] = {
            score_id:
              getScoreRecordId(
                record
              ),

            score_value:
              scoreValue,

            score_text:
              scoreText,

            comment,

            original_score_value:
              scoreValue,

            original_score_text:
              scoreText,

            original_comment:
              comment,
          };
        }
      );
    });

    setScoreDrafts(nextDrafts);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    scoreApiData,
    detailNilaiKhusus,
    selectedKelasId,
    studentDraftSourceKey,
    aspectDraftSourceKey,
  ]);

  useEffect(() => {
    if (
      !examId ||
      !selectedKelasId
    ) {
      setScoreApiData(null);
      setScoreDrafts({});
      return;
    }

    getScoreData(
      selectedKelasId
    );
  }, [
    examId,
    selectedKelasId,
  ]);

  useEffect(() => {
    if (!examId) return;

    const defaultKelasId =
      selectedNilaiKhusus
        ?.ysb_kelas_id ||
      kelasOptions?.[0]?.id ||
      "";

    setActiveTab(
      "detailnilaikhusus"
    );

    setScoreApiData(null);
    setScoreDrafts({});

    setSelectedKelasId(
      defaultKelasId
    );

    getDetailNilaiKhusus(
      defaultKelasId
    );
  }, [examId]);

  useEffect(() => {
    getSubActivityData();
  }, [typeActivityId]);

  const handleChangeKelas = (
    event
  ) => {
    const kelasId =
      event.target.value;

    setSelectedKelasId(kelasId);

    getDetailNilaiKhusus(kelasId);
  };

  const aspectColumnWidth =
    isDescriptiveInput ? 320 : 140;

  const scoreTableMinWidth =
    Math.max(
      isDescriptiveInput
        ? 760
        : 600,

      285 +
        displayAspects.length *
          aspectColumnWidth
    );

  const StatusPill = ({
    label,
    type = "default",
  }) => {
    const background =
      type === "success"
        ? "#dcfce7"
        : type === "danger"
          ? "#fee2e2"
          : type === "warning"
            ? "#fef3c7"
            : type === "primary"
              ? "#dbeafe"
              : "#f3f4f6";

    const color =
      type === "success"
        ? "#15803d"
        : type === "danger"
          ? "#dc2626"
          : type === "warning"
            ? "#b45309"
            : type === "primary"
              ? "#2563eb"
              : "#4b5563";

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: 999,
          padding: "6px 12px",
          background,
          color,
          fontSize: 13,
          fontWeight: 700,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    );
  };

  const DetailInfoCard = ({
    label,
    value,
    children,
    fullWidth = false,
  }) => {
    return (
      <div
        className="exam-info-card"
        style={
          fullWidth
            ? {
                gridColumn:
                  "1 / -1",
              }
            : undefined
        }
      >
        <div className="exam-info-label">
          {label}
        </div>

        <div className="exam-info-value">
          {children ||
            value ||
            "-"}
        </div>
      </div>
    );
  };

  return (
    <div className="body">
      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon
                icon={faListCheck}
              />
            </span>

            <div>
              <h4 className="page-title-text mb-0">
                Nilai Khusus
              </h4>
            </div>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              className="btn btn-light"
              onClick={
                handleBackToNilaiKhusus
              }
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                fontWeight: 600,
              }}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
              />{" "}
              Kembali
            </button>
          </div>
        </div>

        <nav
          aria-label="breadcrumb"
          className="custom-breadcrumb-nav mt-4"
        >
          <ol className="custom-breadcrumb">
            <li className="custom-breadcrumb-item">
              <Link
                to="#"
                onClick={
                  handleBackToNilaiKhusus
                }
              >
                Nilai Khusus
              </Link>
            </li>

            <li className="custom-breadcrumb-separator">
              /
            </li>

            <li
              className="custom-breadcrumb-item active"
              aria-current="page"
            >
              {detailTitle}
            </li>
          </ol>
        </nav>
      </div>

      <div className="body-content">
        <Tabs
          activeKey={activeTab}
          onSelect={(key) => {
            if (key) {
              setActiveTab(key);
            }
          }}
          id="tab-detail-nilai-khusus"
          className="mb-3 nav-tabs"
        >
          <Tab
            eventKey="detailnilaikhusus"
            title="Detail Nilai Khusus"
          >
            <div className="exam-detail-wrapper">
              {isFetchingDetail ? (
                <div className="exam-loading-card">
                  Mengambil detail nilai
                  khusus...
                </div>
              ) : (
                <>
                  <div className="exam-hero-card">
                    <div className="exam-hero-left">
                      <h3 className="exam-hero-title">
                        {detailTitle}
                      </h3>

                      <div className="exam-hero-meta">
                        <span>
                          {matpelName}
                        </span>

                        <span>•</span>

                        <span>
                          {toTitleCase(
                            selectedKelasName
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="exam-hero-right">
                      <StatusPill
                        label={`${totalAssessed}/${
                          totalStudents ||
                          0
                        } Sudah Dinilai`}
                        type={
                          totalAssessed >
                          0
                            ? "success"
                            : "warning"
                        }
                      />

                      <div className="exam-announce-date">
                        {
                          assessmentDateTime
                        }
                      </div>
                    </div>
                  </div>

                  <div className="exam-content-grid mt-3">
                    <div className="exam-main-panel">
                      <div className="exam-section-title">
                        Informasi Penilaian
                      </div>

                      <div className="exam-info-grid">
                        <DetailInfoCard
                          label="Judul"
                          value={
                            detailTitle
                          }
                        />

                        <DetailInfoCard
                          label="Tanggal Penilaian"
                          value={
                            assessmentDateTime
                          }
                        />

                        <DetailInfoCard
                          label="Tipe Kegiatan"
                          value={
                            typeActivityName
                          }
                        />

                        <DetailInfoCard
                          label="Aspek"
                          value={
                            selectedSubActivityName
                          }
                        />

                        <DetailInfoCard
                          label="Keterangan"
                          fullWidth
                        >
                          <div
                            className="exam-muted-text"
                            style={{
                              whiteSpace:
                                "pre-wrap",

                              lineHeight:
                                1.7,
                            }}
                          >
                            {description ||
                              "-"}
                          </div>
                        </DetailInfoCard>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Tab>

          <Tab
            eventKey="nilai"
            title="Nilai"
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 6,
                padding: 15,
              }}
            >
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div className="detail-label">
                    KELAS
                  </div>

                  <select
                    className="form-control"
                    value={
                      selectedKelasId
                    }
                    onChange={
                      handleChangeKelas
                    }
                    style={{
                      height: 35,
                      fontSize: 14,
                    }}
                  >
                    {kelasOptions.length >
                    0 ? (
                      kelasOptions.map(
                        (kelas) => (
                          <option
                            key={
                              kelas?.id
                            }
                            value={
                              kelas?.id
                            }
                          >
                            {toTitleCase(
                              kelas?.name
                            )}
                          </option>
                        )
                      )
                    ) : (
                      <option value="">
                        Kelas belum
                        tersedia
                      </option>
                    )}
                  </select>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="detail-label">
                    KEGIATAN
                  </div>

                  <div className="detail-value text-primary">
                    {typeActivityName}
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="detail-label">
                    SUDAH DINILAI
                  </div>

                  <div className="detail-value text-success">
                    {totalAssessed}/
                    {totalStudents || 0}
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="detail-label">
                    TANGGAL PENILAIAN
                  </div>

                  <div className="detail-value">
                    {
                      assessmentDateTime
                    }
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="detail-label">
                    ASPEK
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gap: 6,
                    }}
                  >
                    {isFetchingAspek ? (
                      <span className="exam-muted-text">
                        Mengambil aspek
                        penilaian...
                      </span>
                    ) : detailAspects.length >
                      0 ? (
                      detailAspects.map(
                        (aspect) => (
                          <span
                            key={
                              aspect?.id
                            }
                            style={{
                              fontSize:
                                "13px",
                            }}
                          >
                            {aspect?.name ||
                              "-"}
                          </span>
                        )
                      )
                    ) : (
                      <span className="exam-muted-text">
                        Aspek belum tersedia
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="detail-label mb-3">
                NILAI KHUSUS
              </div>

              <Col
                xl="12"
                sm="12"
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <div
                  className="mt-3 body-table"
                  style={{
                    overflowX: "auto",
                  }}
                >
                  <table
                    className="table table-hover table-border-style"
                    id="basic-datatable"
                    style={{
                      width: "100%",
                      minWidth:
                        scoreTableMinWidth,
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            width: 55,
                            minWidth: 55,
                            textAlign:
                              "center",
                            verticalAlign:
                              "middle",
                          }}
                        >
                          No
                        </th>

                        <th
                          style={{
                            minWidth: 230,
                            verticalAlign:
                              "middle",
                          }}
                        >
                          Nama
                        </th>

                        {displayAspects.map(
                          (aspect) => (
                            <th
                              key={
                                aspect?.id
                              }
                              style={{
                                width:
                                  aspectColumnWidth,

                                minWidth:
                                  aspectColumnWidth,

                                textAlign:
                                  "center",

                                verticalAlign:
                                  "middle",
                              }}
                            >
                              {aspect?.name ||
                                "Nilai"}
                            </th>
                          )
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {isFetchingScores ||
                      isFetchingDetail ? (
                        <tr>
                          <td
                            colSpan={
                              2 +
                              displayAspects.length
                            }
                            className="text-center p-4"
                          >
                            Mengambil data
                            nilai siswa...
                          </td>
                        </tr>
                      ) : students.length >
                        0 ? (
                        students.map(
                          (
                            student,
                            index
                          ) => (
                            <tr
                              key={
                                student?.id ||
                                index
                              }
                              style={{
                                background:
                                  index %
                                    2 ===
                                  0
                                    ? "#f7fafe"
                                    : "#fff",
                              }}
                            >
                              <td
                                style={{
                                  textAlign:
                                    "center",

                                  verticalAlign:
                                    "middle",
                                }}
                              >
                                {index + 1}
                              </td>

                              <td
                                style={{
                                  verticalAlign:
                                    "middle",
                                }}
                              >
                                <div
                                  style={{
                                    display:
                                      "flex",

                                    alignItems:
                                      "center",

                                    gap: 10,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight:
                                        500,
                                    }}
                                  >
                                    {student?.name ||
                                      "-"}
                                  </span>
                                </div>
                              </td>

                              {displayAspects.map(
                                (aspect) => {
                                  const key =
                                    getScoreCellKey(
                                      student?.id,
                                      aspect?.id
                                    );

                                  const draft =
                                    scoreDrafts[
                                      key
                                    ] || {};

                                  const isSaving =
                                    Boolean(
                                      savingScoreKeys[
                                        key
                                      ]
                                    );

                                  return (
                                    <td
                                      key={
                                        aspect?.id
                                      }
                                      style={{
                                        width:
                                          aspectColumnWidth,

                                        minWidth:
                                          aspectColumnWidth,

                                        verticalAlign:
                                          "middle",
                                      }}
                                    >
                                      {isDescriptiveInput ? (
                                        <textarea
                                          className="exam-score-textarea"
                                          rows={
                                            3
                                          }
                                          value={safeStr(
                                            draft?.score_text
                                          )}
                                          disabled={
                                            isSaving
                                          }
                                          // placeholder="Masukkan deskripsi penilaian"
                                          onChange={(
                                            event
                                          ) =>
                                            updateScoreDraft(
                                              student,
                                              aspect,
                                              "score_text",
                                              event
                                                .target
                                                .value
                                            )
                                          }
                                          onBlur={() =>
                                            saveScore(
                                              student,
                                              aspect
                                            )
                                          }
                                        />
                                      ) : (
                                        <input
                                          type="number"
                                          className="exam-score-input"
                                          value={safeStr(
                                            draft?.score_value
                                          )}
                                          disabled={
                                            isSaving
                                          }
                                          step="any"
                                          // placeholder="Nilai"
                                          onChange={(
                                            event
                                          ) =>
                                            updateScoreDraft(
                                              student,
                                              aspect,
                                              "score_value",
                                              event
                                                .target
                                                .value
                                            )
                                          }
                                          onBlur={() =>
                                            saveScore(
                                              student,
                                              aspect
                                            )
                                          }
                                          onKeyDown={(
                                            event
                                          ) => {
                                            if (
                                              event.key ===
                                              "Enter"
                                            ) {
                                              event.preventDefault();

                                              event.currentTarget.blur();
                                            }
                                          }}
                                        />
                                      )}
                                    </td>
                                  );
                                }
                              )}
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan={
                              2 +
                              displayAspects.length
                            }
                            className="text-center p-4"
                          >
                            Data nilai siswa
                            belum tersedia
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>
            </div>
          </Tab>
        </Tabs>
      </div>

      <style>
        {`
          .detail-label {
            font-size: 13px;
            color: #535353;
            font-weight: 700;
            margin-bottom: 7px;
          }

          .detail-value {
            font-size: 14px;
            font-weight: 700;
          }

          .text-primary {
            color: #006fb2 !important;
          }

          .text-success {
            color: #00a86b !important;
          }

          .text-danger {
            color: #ef4444 !important;
          }

          .body-table .form-control {
            height: 38px;
            border-radius: 7px;
          }

          .exam-detail-wrapper {
            display: grid;
            gap: 16px;
          }

          .exam-score-input,
          .exam-score-textarea {
            width: 100%;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background: #ffffff;
            color: #111827;
            font-size: 13px;
            outline: none;
            transition:
              border-color 0.15s ease,
              box-shadow 0.15s ease;
          }

          .exam-score-input {
            height: 40px;
            padding: 0 12px;
            text-align: center;
            font-weight: 700;
            color: #0067b9;
          }

          .exam-score-textarea {
            min-height: 76px;
            padding: 10px 12px;
            resize: vertical;
            line-height: 1.5;
            text-align: left;
            white-space: pre-wrap;
          }

          .exam-score-input:focus,
          .exam-score-textarea:focus {
            border-color: #60a5fa;
            box-shadow:
              0 0 0 3px
              rgba(96, 165, 250, 0.16);
          }

          .exam-score-input:disabled,
          .exam-score-textarea:disabled {
            cursor: wait;
            background: #f3f4f6;
          }

          #basic-datatable {
            width: 100%;
            margin-bottom: 0;
          }

          #basic-datatable thead th {
            background: #f3f6fc;
            color: #063b85;
            border-color: #dbe5f1;
            font-size: 13px;
            font-weight: 700;
            white-space: nowrap;
          }

          #basic-datatable tbody td {
            padding: 10px 12px;
            border-color: #e5edf7;
          }

          .exam-loading-card {
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 14px;
            padding: 22px;
            color: #404040;
            font-weight: 600;
            text-align: center;
          }

          .exam-hero-card {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            background: linear-gradient(
              135deg,
              #ffffff 0%,
              #eef6ff 100%
            );
            border: 1px solid #e5edf7;
            border-radius: 18px;
            padding: 22px;
            box-shadow:
              0 10px 28px
              rgba(15, 23, 42, 0.06);
          }

          .exam-hero-left {
            flex: 1;
            min-width: 0;
          }

          .exam-hero-title {
            color: #0f172a;
            font-size: 24px;
            font-weight: 800;
            line-height: 1.3;
            margin: 0;
            text-transform: capitalize;
          }

          .exam-hero-meta {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            color: #64748b;
            font-size: 14px;
            font-weight: 600;
            margin-top: 8px;
          }

          .exam-hero-right {
            min-width: 220px;
            text-align: right;
          }

          .exam-announce-date {
            margin-top: 8px;
            color: #64748b;
            font-size: 13px;
            font-weight: 600;
          }

          .exam-content-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .exam-main-panel {
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 18px;
            padding: 18px;
            box-shadow:
              0 4px 14px
              rgba(15, 23, 42, 0.03);
          }

          .exam-section-title {
            color: #0f172a;
            font-size: 15px;
            font-weight: 800;
            margin-bottom: 16px;
          }

          .exam-info-grid {
            display: grid;
            grid-template-columns:
              repeat(3, minmax(0, 1fr));
            gap: 14px;
          }

          .exam-info-card {
            background: #f8fafc;
            border: 1px solid #edf2f7;
            border-radius: 14px;
            padding: 15px;
            min-width: 0;
          }

          .exam-info-label {
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
            text-transform: uppercase;
            margin-bottom: 7px;
          }

          .exam-info-value {
            color: #111827;
            font-size: 14px;
            font-weight: 800;
            line-height: 1.6;
            overflow-wrap: anywhere;
          }

          .exam-muted-text {
            color: #6b7280;
            font-size: 13px;
            font-weight: 600;
          }

          #tab-detail-nilai-khusus-tab-detailnilaikhusus,
          #tab-detail-nilai-khusus-tab-nilai {
            font-weight: 600;
          }

          @media (max-width: 1199px) {
            .exam-info-grid {
              grid-template-columns:
                repeat(2, minmax(0, 1fr));
            }
          }

          @media (max-width: 991px) {
            .exam-hero-card {
              flex-direction: column;
              align-items: flex-start;
            }

            .exam-hero-right {
              text-align: left;
              min-width: auto;
            }

            .exam-info-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 575px) {
            .exam-hero-card {
              padding: 17px;
              border-radius: 14px;
            }

            .exam-hero-title {
              font-size: 20px;
            }

            .exam-main-panel {
              padding: 15px;
              border-radius: 14px;
            }
          }
        `}
      </style>
    </div>
  );
}